/**
 * Whether the back office is open at an address with no organisation behind it (#181).
 *
 * The app answers on every address in the domain list, and the list and the `orgs` table can
 * disagree: onboarding half done, or an org removed or renamed while its address stays. On such
 * an address the login still works (it needs no org) and every scoped read then 404s, so it used
 * to look like a working, empty Verlo back office. Two signals say so instead:
 *
 *   - before sign-in, `GET /branding` answers `host: "unknown"` (`backend/routes/branding.py`);
 *   - after it, a scoped read answers 404 with `UNKNOWN_ORGANISATION`, which also covers an org
 *     removed mid-session.
 *
 * `HostGate` reads both and shows `NoOrganisationPage` in place of the app.
 */

/** `scoping.get_scope`'s 404 detail, word for word (`scoping.UNKNOWN_ORGANISATION`). */
export const UNKNOWN_ORGANISATION = 'Unknown organisation for host';

/** `GET /branding`'s answer says this address names no live org. */
export const isUnknownHost = (branding) => branding?.host === 'unknown';

/** An API error is the 404 a scoped read answers on such an address. */
export const isUnknownOrganisationError = (error) =>
  error?.response?.status === 404 && error.response.data?.detail === UNKNOWN_ORGANISATION;
